<template>
  <div class="Openings">
    <h4 class="title">{{ $t('jobs_page.header_six') }}</h4>
    <section class="job-filters-controls">
      <div
        class="Filter-Options"
        style="--factor: 1;"
        v-if="open_location_filters"
        ref="optionsRefLoc"
      >
        <div
          v-for="location in locations"
          :key="location"
          class="Filter-Card"
          :data-active="
            location_filters.find(job => location.startsWith(job.jobFilter))
              ? true
              : false
          "
          @click="add('location', location)"
        >
          <p>{{ location }}</p>
          <div>
            <img src="~@/assets/careers/selected.svg" data-active="true" />
            <div class="plus">
              <div class="vertical" />
              <div class="horizontal" />
            </div>
          </div>
        </div>
      </div>
      <div
        class="Filter-Options"
        style="--factor: -1;"
        ref="optionsRefDep"
        v-if="open_department_filters"
      >
        <div
          v-for="department in departments"
          :key="department"
          :data-active="
            department_filters.find(job => job.jobFilter === department)
              ? true
              : false
          "
          class="Filter-Card"
          @click="add('department', department)"
        >
          <p>{{ department }}</p>
          <div>
            <img src="~@/assets/careers/selected.svg" data-active="true" />
            <div class="plus">
              <div class="vertical" />
              <div class="horizontal" />
            </div>
          </div>
        </div>
      </div>
      <div @click="openFilter('location')">
        <Card type="small" :active="open_location_filters">
          <p class="card-text">
            {{ $t('jobs_page.filter1_title') }}
            <span v-if="location_filters.length"
              >({{ location_filters.length }})</span
            >
          </p>
          <div :data-active="open_location_filters" class="card-link">
            <img
              :src="
                require(`@/assets/careers/arrow_${
                  open_location_filters ? 'light' : 'dark'
                }.svg`)
              "
            />
          </div>
        </Card>
      </div>
      <div @click="openFilter('department')">
        <Card type="small" :active="open_department_filters">
          <p class="card-text">
            {{ $t('jobs_page.filter2_title') }}

            <span v-if="department_filters.length"
              >({{ department_filters.length }})</span
            >
          </p>
          <a :data-active="open_department_filters" class="card-link"
            ><img
              :src="
                require(`@/assets/careers/arrow_${
                  open_department_filters ? 'light' : 'dark'
                }.svg`)
              "
          /></a>
        </Card>
      </div>
    </section>
    <section class="filters-list">
      <div
        v-for="{ jobFilter, type } in [
          ...location_filters,
          ...department_filters,
        ]"
        :key="jobFilter"
        class="job-filter-bullet"
      >
        <p>{{ jobFilter }}</p>
        <div @click="remove({ type, currentFilter: jobFilter })" class="job-x">
          <div class="remove">
            <div class="cross_v" />
            <div class="cross_h" />
          </div>
        </div>
      </div>
    </section>
    <section class="jobs-list">
      <template>
        <a
          v-for="({ name, url }, i) in filteredJobs"
          :key="i"
          :target="isMobile ? null : '_blank'"
          :href="url"
        >
          <Card type="big">
            <p class="card-text">{{ name }}</p>
            <img src="~@/assets/careers/go_to_pdf.svg" class="card-link" />
          </Card>
        </a>
      </template>
    </section>
  </div>
</template>

<script>
import Card from './Card.vue';

export default {
  components: { Card },
  data() {
    return {
      isMobile: window.innerWidth <= 768,
      departments: [],
      locations: [],
      open_location_filters: false,
      open_department_filters: false,
      skipFirstClick: true,
      location_filters: [],
      department_filters: [],
      jobs: [],
      isiOS: navigator.userAgent.includes('iPhone'),
    };
  },
  methods: {
    async fetchJobs() {
      const result = await fetch(
        'https://api.lever.co/v0/postings/qwello.eu?mode=json'
      );
      const parsedJson = await result.json();

      this.jobs = parsedJson.map(job => ({
        ...job,
        name: job.text,
        url: job.hostedUrl,
      }));

      // Quick fix. A bit gross but solves it for now
      // Issue is that the departments and locations come from lever
      // So this just takes all the unique locations+departments
      // and takes the very first word since some of them
      // are quite long.
      this.locations = [
        ...new Set(
          parsedJson.map(({ categories: { location } }) =>
            location
              .split(' ')
              .shift()
              .replace(',', '')
          )
        ),
      ];
      this.departments = [
        ...new Set(
          parsedJson.map(({ categories: { department } }) =>
            department.split(' ').shift()
          )
        ),
      ];
    },
    openFilter(type) {
      if (type === 'location') {
        this.open_location_filters = true;
        this.open_department_filters = false;
        return;
      }
      this.open_department_filters = true;
      this.open_location_filters = false;
    },
    remove({ type, currentFilter }) {
      if (type === 'location') {
        this.location_filters = this.location_filters.filter(
          ({ jobFilter }) => jobFilter !== currentFilter
        );
        return;
      }
      this.department_filters = this.department_filters.filter(
        ({ jobFilter }) => jobFilter !== currentFilter
      );
    },
    add(type, jobFilter) {
      if (
        type === 'location' &&
        !this.location_filters.find(job => job.jobFilter === jobFilter)
      ) {
        this.location_filters.push({ type, jobFilter });
      } else if (
        type === 'department' &&
        !this.department_filters.find(job => job.jobFilter === jobFilter)
      ) {
        this.department_filters.push({ type, jobFilter });
      } else {
        this.remove({ type, currentFilter: jobFilter });
      }
    },
    hasDepartment(array, department) {
      return (
        array.some(el => department.startsWith(el.jobFilter)) || !array.length
      );
    },
    hasLocation(array, location) {
      return (
        array.some(el => location.startsWith(el.jobFilter)) || !array.length
      );
    },
    handleClick(event) {
      if (this.skipFirstClick) {
        this.skipFirstClick = false;
        return;
      }
      if (
        this.open_location_filters &&
        !this.$refs.optionsRefLoc.contains(event.target)
      ) {
        this.open_location_filters = false;
      } else if (
        this.open_department_filters &&
        !this.$refs.optionsRefDep.contains(event.target)
      ) {
        this.open_department_filters = false;
      }
      this.skipFirstClick = true;
    },
    checkForMobile() {
      if (window.innerWidth <= 768 && this.isMobile === false) {
        this.isMobile = true;
      } else if (window.innerWidth > 768 && this.isMobile === true) {
        this.isMobile = false;
      }
    },
  },
  computed: {
    filteredJobs() {
      return this.location_filters.length || this.department_filters.length
        ? this.jobs.filter(
            job =>
              this.hasLocation(
                this.location_filters,
                job.categories.location
              ) &&
              this.hasDepartment(
                this.department_filters,
                job.categories.department
              )
          )
        : this.jobs;
    },
  },
  mounted() {
    window.addEventListener('resize', this.checkForMobile);
    document.body.addEventListener('click', this.handleClick);
    // fetch jobs
    this.fetchJobs();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkForMobile);
    document.body.removeEventListener('click', this.checkForMobile);
  },
};
</script>

<style scoped>
.Openings {
  margin-top: 4em;
  margin-bottom: 8.3em;
  --openings-title-f-size: 30px;
  --openings-card-text-f-size: 14px;
  --jobs-list-width: 85%;
  --jobs-list-justify: normal;
  --jobs-list-grid-gap: 20px;
  --filter-options-width: 80%;
  --filter-card-f-size: 14px;
  --filter-options-grid: repeat(auto-fit, minmax(auto, 136px));
  --filter-list-max-size: 80%;
}
.title {
  text-align: center;
  color: var(--page-text-color);
  font-size: var(--openings-title-f-size);
  font-weight: bold;
  font-family: 'Foco';
}
.paragraph {
  color: var(--page-text-color);
  font-size: var(--openings-text-f-size);
  text-align: center;
  max-width: 55%;
  margin: 2em auto 0 auto;
}
.job-filters-controls {
  position: relative;
  margin-top: 4em;
  display: flex;
  justify-content: center;
}
.job-filters-controls > div {
  margin-right: 1em;
}
.filters-list {
  position: relative;
  min-height: 50px;
  max-width: var(--filter-list-max-size);
  margin: 5px auto;
  display: flex;
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
}
.job-filter-bullet {
  background: #12a29133;
  color: #12a291;
  font-size: 18px;
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  justify-items: center;
  max-width: 150px;
  padding: 0 15px 0 15px;
  height: 38px;
  border-radius: 35px;
  text-transform: capitalize;
  margin-right: 15px;
  overflow: hidden;
  margin-bottom: 15px;
}
.job-x {
  margin-left: 15px;
  width: min-content;
  cursor: pointer;
}
.jobs-list {
  display: grid;
  max-width: var(--jobs-list-width);
  margin: 0 auto;
  grid-gap: var(--jobs-list-grid-gap);
  justify-content: var(--jobs-list-justify);
  grid-template-columns: var(--jobs-list-grid-col);
}
.card-link {
  height: min-content;
  align-self: center;
  cursor: pointer;
  transition: transform 0.25s cubic-bezier(0.075, 0.82, 0.165, 1);
}
.card-link[data-active='true'] {
  transform: rotate(180deg);
}
.card-text {
  align-self: center;
  font-size: var(--openings-card-text-f-size);
  font-family: 'Foco';
  color: inherit;
  flex-grow: 1;
}
@media (min-width: 768px) {
  .Openings {
    --openings-title-f-size: 32px;
    --jobs-list-width: 65%;
    --jobs-list-grid-col: repeat(2, minmax(45%, 360px));
    --jobs-list-justify: center;
    --filter-options-width: auto;
    --filter-options-grid: repeat(auto-fit, minmax(auto, 150px));
    --filter-card-f-size: 16px;
    --openings-card-text-f-size: 20px;
    --filter-list-max-size: 45%;
    --jobs-list-grid-gap: 2.4em;
  }
  .Filter-Options {
    transform: translateX(calc(-45% * var(--factor)));
  }
}
.Filter-Options {
  z-index: 100;
  position: absolute;
  display: grid;
  gap: 1em;
  top: 110%;
  grid-template-columns: var(--filter-options-grid);
  align-items: center;
  width: var(--filter-options-width);
  max-width: 80%;
  margin: 0 auto;
  min-height: 94px;
  border-radius: 8px;
  background: #12a291;
  padding: 1.2em;
}

.Filter-Card {
  cursor: pointer;
  background: transparent;
  border: 1px solid white;
  padding: 1em;
  color: white;
  border-radius: 8px;
  display: grid;
  font-size: var(--filter-card-f-size);
  grid-template-columns: 1fr auto;
  align-items: center;
  text-transform: capitalize;
}
.Filter-Card img {
  display: none;
  height: 14px;
  width: 14px;
}
.Filter-Card[data-active='true'] {
  background: white;
  color: green;
}
.plus {
  display: grid;
  justify-self: center;
  place-items: center;
  height: 14px;
  width: 14px;
}
.Filter-Card[data-active='true'] .plus {
  display: none;
}
.Filter-Card[data-active='true'] img {
  display: block;
}
.plus > * {
  grid-area: 1 / 1;
}
.vertical {
  height: 100%;
  width: 1px;
  background: white;
}
.horizontal {
  width: 100%;
  height: 1px;
  background: white;
}
.remove {
  display: grid;
  place-items: center;
  height: 16px;
  width: 16px;
  transform: rotate(45deg);
}
.remove > * {
  grid-area: 1 / 1;
}
.cross_v,
.cross_h {
  background: #12a291;
}
.cross_v {
  height: 100%;
  width: 2px;
}
.cross_h {
  width: 100%;
  height: 2px;
}
</style>
